// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LMDataService } from '@services/lm-data.service';
import * as urltemplate from 'url-template';
import { Observable, throwError } from 'rxjs';
import { LMUrlUtilService } from '@services/utils/lm-url-util.service';

@Injectable()
export class LMFormPagingService {

  constructor(
    private http: HttpClient,
    private lmUrlUtilService: LMUrlUtilService,
    private lmDataService: LMDataService
  ) {}

  /**
   * Retrieves an initial record of data for a form
   */
  public loadRecord(url: string): Observable<LMDataView> {
    return this.lmDataService.getRecord(url);
  }

  nextRecord(dataView: LMDataView): Observable<LMDataView> {
    if (!dataView) {
      return throwError('Invalid arguments: dataView is a required argument');
    }

    const url: string = dataView.pagingUrls.nextRecordUrl;
    return this.lmDataService.getRecord(url);
  }

  previousRecord(dataView: LMDataView): Observable<LMDataView> {
    if (!dataView) {
      return throwError('Invalid arguments: dataView is a required argument');
    }

    const url: string = dataView.pagingUrls.previousRecordUrl;
    return this.lmDataService.getRecord(url);
  }

  loadTemplateRecords(formUrlInfo: LMFormUrlInfo, formSpec: LMFormSpec, fromDataView: LMDataView, sourceDataView: LMDataView, displayWhenIndex: number): Observable<LMDataViewSet> {
    if (!formSpec || !fromDataView) {
      return throwError('Invalid arguments: formSpec is a required argument');
    }

    const urlCompiledTemplate = urltemplate.parse(formUrlInfo.initialDataUrl);
    let url: string;

    if (sourceDataView) {
      url = urlCompiledTemplate.expand({
        resourceId: fromDataView.resourceId,
        sourceResourceId: sourceDataView.resourceId
      });
    } else {
      url = urlCompiledTemplate.expand({ resourceId: fromDataView.resourceId });
    }

    if (displayWhenIndex) {
      // this is only required in a sub panel
      url = url + '&displayWhenIndex=' + displayWhenIndex;
    }

    return this.lmDataService.getTemplateRecords(url);
  }

  loadSubPanels(dataView: LMDataView, loadPanelSubStepsURL: string): Observable<LMDataViewSet> {
    const urlCompiledTemplate = urltemplate.parse(loadPanelSubStepsURL);
    const url = urlCompiledTemplate.expand({ resourceId: dataView.resourceId });
    return this.lmDataService.getSubPanelRecords(url);
  }

  refreshRecord(dataView: LMDataView, navigationContext?: LMNavContextKeys): any {
    if (!dataView) {
      return throwError('Invalid arguments: dataView is a required argument');
    }

    let url: string = dataView.pagingUrls.reloadRecordUrl;
    if (navigationContext) {
      url = this.lmUrlUtilService.appendToQueryString(url, this.lmUrlUtilService.objectToQueryString(navigationContext))
    }
    return this.lmDataService.getRecord(url);
  }

  loadRelatedRecord(dataView: LMDataView): any {
    if (!dataView) {
      return throwError('Invalid arguments: dataView is a required argument');
    }

    const url: string = dataView.pagingUrls.reloadRecordUrl;
    return this.lmDataService.getRecord(url);
  }
}
